export const reportsState: aboTheme.IState = {
    parent: "app",
    name: "reports",
    url: "/reports",
    redirectTo: "reports.hours",
    component: "reportsComponent",
    data: {
        permissions: {
            only: ['FINANCE', 'BACKOFFICE'],
            redirectTo: 'dashboard'
        }
    }
};

export const reportsHoursState: aboTheme.IState = {
    name: "reports.hours",
    url: "/hours",
    views: {
        "main": 'reportsHoursComponent'
    },
    data: {
        permissions: {
            only: ['FINANCE', 'BACKOFFICE'],
            redirectTo: 'dashboard'
        }
    }
};

export const reportsLegerState: aboTheme.IState = {
    name: "reports.leger",
    url: "/leger",
    views: {
        "main": 'reportsLegerComponent'
    },
    data: {
        permissions: {
            only: ['FINANCE', 'BACKOFFICE'],
            redirectTo: 'dashboard'
        }
    }
};

export const reportsGrossAllowanceState: aboTheme.IState = {
    name: "reports.grossAllowance",
    url: "/gross-allowance",
    views: {
        "main": 'reportsGrossAllowanceComponent'
    },
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'dashboard'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/modules/reports/reports.states.ts